export default "__VITE_ASSET__BbVvlAvx__"